import { TeamContainersParams } from '../videos.thunks';

export const isTeamContainersParams = (obj: unknown): obj is TeamContainersParams =>
  typeof obj === 'object' && obj !== null && 'teamKey' in obj && typeof obj.teamKey === 'string';
